export default "__VITE_ASSET__0MMzm6ed__"